import { differenceInDays, isBefore, sub } from 'date-fns';
import { NO_DATA } from '../../../Base.constants';
import { CqsMetric, CreMetric, HistoricalRecord } from '../../../models/RiskProducts';
import { DATE_FORMATS, parseDate } from '../../../utils/dateUtils';
import { hasCqsMetrics } from './CqsChart/CqsChart.logic';
import { hasCreMetrics } from './CreChart/CreChart.logic';
import { STARTING_DATE_RANGE } from './RiskProductsWidget.logic.constants';

export const hasCompanyRiskMetrics = (cqsMetrics: CqsMetric[], creMetrics: CreMetric[]): boolean => {
  return hasCqsMetrics(cqsMetrics) || hasCreMetrics(creMetrics);
};

// ------------ Filter risk metrics ------------

export const filterRiskMetricsByYearRange = (riskMetrics: HistoricalRecord[]): HistoricalRecord[] => {
  const startingDate = riskMetricsStartingDate(riskMetrics[0].calculation_date);
  return riskMetrics.filter((metric) =>
    isBefore(startingDate, parseDate(metric.calculation_date, DATE_FORMATS.YEAR_MONTH_DAY))
  );
};

export const riskMetricsStartingDate = (latestRiskMetricDate: string): Date => {
  const latestRiskMetricISODate = parseDate(latestRiskMetricDate, DATE_FORMATS.YEAR_MONTH_DAY);
  return sub(latestRiskMetricISODate, { years: STARTING_DATE_RANGE });
};

export const getMetricTag = (value?: string | number | null): string => value?.toString() ?? NO_DATA;

// ------------ Years Axis Block ------------
export const mapRiskMetricsToYearsAxisValues = (riskMetrics: CqsMetric[] | CreMetric[]): number[] => {
  const startingDate = riskMetricsStartingDate(riskMetrics[0].calculationDate);
  return riskMetrics.map((metric) =>
    differenceInDays(parseDate(metric.calculationDate, DATE_FORMATS.YEAR_MONTH_DAY), startingDate)
  );
};

export const sortMetricsDescByCalculationDate = <T extends CqsMetric | CreMetric>(metrics: T[]): T[] => {
  return [...metrics].sort((a, b) => new Date(b.calculationDate).valueOf() - new Date(a.calculationDate).valueOf());
};
